import { cn } from "@/lib/utils";

interface PageHeaderProps {
	children: React.ReactNode;
	className?: string;
}

export function PageHeader({ children, className }: PageHeaderProps) {
	return (
		<div
			className={cn(
				"flex flex-col gap-4 pb-6 md:flex-row md:items-center md:justify-between",
				className,
			)}
		>
			{children}
		</div>
	);
}

interface PageHeaderHeadingProps {
	children: React.ReactNode;
	description?: React.ReactNode;
	className?: string;
}

export function PageHeaderHeading({
	children,
	description,
	className,
}: PageHeaderHeadingProps) {
	return (
		<div className={cn("space-y-1", className)}>
			<h1 className="text-2xl font-semibold tracking-tight">{children}</h1>
			{description && (
				<p className="text-sm text-muted-foreground">{description}</p>
			)}
		</div>
	);
}

interface PageHeaderActionsProps {
	children: React.ReactNode;
	className?: string;
}

export function PageHeaderActions({
	children,
	className,
}: PageHeaderActionsProps) {
	return (
		<div className={cn("flex items-center gap-2", className)}>{children}</div>
	);
}
